import apiClient from '@/services/axios'

export async function patch(patchClosedRequest) {

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-notes/update-booking-closed', patchClosedRequest);
  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to patch the venue closed note.');
}
